const homepageStats = document.querySelector(".content-text-stats");

const separateNumber = (target) => {
  const value = target.text();
  const num = value.match(/\d+/g);
  const letter = value.match(/[a-zA-Z+]+/g);

  if (num && letter) {
    target.replaceWith(`
      <div class="content-text-stats__wrapper">
        <p class="content-text-stats__number">${num[0]}</p>
        <p class="content-text-stats__letter">${letter.join(' ')}</p>
      </div>`);
  } else {
    target.replaceWith(`
      <div class="content-text-stats__wrapper">
        <p class="content-text-stats__number">${num[0]}</p>
      </div>`);
  }
}

/**
 * @description - Function checks if element is in the viewport and adds appropriate class to it.
 */
const showStatsWhenInViewport = debounce(() => {
  if (homepageStats && isInViewport(homepageStats)) {
    if (!$(homepageStats).hasClass("in-viewport")) {
      setTimeout(function() {
        $(homepageStats)
          .find(".content-text-stats__number")
          .each(function() {
            if (!$(homepageStats).hasClass("in-viewport")) {
              const currentNumber = $(this);
              $(this).animateNumber({ number: $(this).text() }, 2500);
            }
          });
          homepageStats.classList.add("in-viewport");
      }, 1000);
    }
  }
}, 30);

/**
 * Initialize functions on start and on scroll
 */
$(document).ready(function() {
  $(homepageStats).find(".content-text-stats__stats div").each(function () {

    separateNumber($(this));
  });
  showStatsWhenInViewport();
});

$(window).on("scroll touchmove", showStatsWhenInViewport);
